import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import { Grid, Tooltip, useMediaQuery } from "@mui/material";

import "./form.css";
import "animate.css";

import iconEdit from "../img/iconEdit.svg";
import iconInitial from "../img/tabla/iconInitial.svg";

import { ModalProgress } from "../../modals/ModalProgress";
import { DialogInitialService } from "./DialogInitialService";

import { ModalListaGastos } from "../../pptos_gastos/ModalListaGastos";
import { ModalListaFacturas } from "../../invoices/modalListaInvoices/ModalListaFacturas";

import { CardTotalCliente } from "./CardTotalCliente";
import { CardGastoP } from "./CardGastoP";
import { CardUtilidadP } from "./CardUtilidadP";
import { CardGastoR } from "./CardGastoR";
import { CardUtilidadR } from "./CardUtilidadR";

import { FormActions } from "./FormActions";
import { PptosFormModalDatosIniciales } from "./PptosFormModalDatosIniciales";
import { PptosCondiciones } from "./PptosCondiciones";

import {
  iniLoadBudgetsDetail,
  iniAddTitleWithItems,
  iniCreateBudget,
  updateNewFolio,
} from "../../../redux/actions/pptos";

import TablaPptos from "./tablaPresupuestos/TablaPptos";
import { PptosMasTotales } from "./PptosMasTotales";
// import { SectionExpectedProfit } from './SectionExpectedProfit'
import { PptosInfoFacturacion } from "./PptosInfoFacturacion";
// import { useRef } from 'react'
import { PptosDialogLinkProjects } from "./PptosDialogLinkProjects";
// import { DialogModal } from '../../reusableUI/DialogModal'
// import { ProjectionsFormCustomer } from '../../reportes/FlujoCaja/ProjectionsFormCustomer'

import { useProjections } from "../../../hooks/useProjections";
// import { Projections } from '../Projections/Projections'
import { CardTotalFacturacion } from "./CardTotalFacturacion";
// import { ProjectsTaskNew } from '../../projects/tasks/ProjectsTaskNew'
import { ProjectsTaskNew2 } from "../../projects/tasks/ProjectsTaskNew2";
// import { CardTotalProyectado, CardTotalProyectadoIngresos } from './CardTotalProyectadoIngresos'
// import { CardTotalCobrado } from './CardTotalCobrado'
// import { CardTotalPagado } from './CardTotalPagado'
// import { CardTotalProyectadoEgresos } from './CardTotalProyectadoEgresos'
import { DialogFlowGeneral } from "./flows/DialogFlowGeneral";
import { Resumen } from "../resumen/Resumen";
import { TaskOneMovil } from "../../tasks/TaskOneMovil";
import { Model } from "../../../models/model";
import { DialogFormMovil } from "../../tasks/DialogFormMovil";
import { DialogImports } from "./flows/DialogImports";
import { Import } from "lucide-react";
import { ProjectsTaskNewV3 } from "../../projects/tasks/ProjectsTaskNewV3";

export const PptosForm = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const urlParams = useParams();
  const { budgetId } = urlParams;
  const dispatch = useDispatch();

  const { access, perfil } = useSelector((state) => state.auth);
  const { openProgress } = useSelector((state) => state.general);
  const { detail } = useSelector((state) => state.ppto);

  const {
    // id,
    // referencia,
    // cliente,
    items,
    estado_negocio,
    // id_cliente,
    // total_cliente,
    // projections,
    validacion_estado,
  } = detail;

  const [open, setOpen] = useState(false);
  const [openLinkProject, setOpenLinkProject] = useState(false);

  const [openCond, setOpenCond] = useState(false);
  const [openMasTotales, setOpenMasTotales] = useState(false);
  const [openInfoFacturacion, setOpenInfoFacturacion] = useState(false);

  const [openInitialServices, setOpenInitialServices] = useState(false);

  const [openListCompras, setOpenListCompras] = useState(false);
  const [itemPptoSelected, setItemPptoSelected] = useState(null);

  const [openListFacturas, setOpenListFacturas] = useState(false);
  const [openDialogModalProjections, setOpenDialogModalProjections] =
    useState(false);
  const [openDialogModalImports, setOpenDialogModalImports] = useState(false);

  const [showOptionMenu, setShowOptionMenu] = useState(
    estado_negocio === "aprobado" ? "resumen" : "items",
  );

  const { initLoadProjections } = useProjections();

  const addTitle = () => {
    dispatch(iniAddTitleWithItems(items));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadIni = useCallback(async () => {
    dispatch(iniLoadBudgetsDetail(budgetId));

    if (parseFloat(budgetId) === 0) {
      setOpen(true);
    }
  }, [dispatch, budgetId]);

  const handleCloseListCompras = () => {
    setOpenListCompras(false);
  };

  const handleOpenListCompras = (by, item = null) => {
    setItemPptoSelected(item);
    setOpenListCompras(true);
  };

  useEffect(() => {
    if (detail.estado_negocio === "aprobado") {
      initLoadProjections({
        id_ppto: detail.id,
        customer: detail.cliente,
        total_ppto: detail.total_cliente,
        referencia: detail.referencia,
        id_customer: detail.id_cliente,
        projections: detail.projections,
        detail_ppto: detail,
      });
    }
  }, [detail, initLoadProjections]);

  useEffect(() => {
    if (perfil === 9) {
      setShowOptionMenu(estado_negocio === "aprobado" ? "tasks" : "tasks");
    } else {
      setShowOptionMenu(estado_negocio === "aprobado" ? "resumen" : "items");
    }
  }, [estado_negocio, perfil]);

  useEffect(() => {
    loadIni();

    return () => {
      dispatch(iniCreateBudget());
    };
  }, [dispatch, loadIni]);

  return (
    <div className={`p-pptos ${isMobile ? "p-3" : ""}`}>
      {openProgress && <ModalProgress />}

      {open && (
        <PptosFormModalDatosIniciales
          open={open}
          handleClose={handleClose}
          title="Datos del presupuesto"
        />
      )}

      {openLinkProject && (
        <PptosDialogLinkProjects
          open={openLinkProject}
          setOpen={setOpenLinkProject}
        />
      )}

      {openCond && (
        <PptosCondiciones
          open={openCond}
          setOpen={setOpenCond}
          title="Condiciones"
        />
      )}

      {openMasTotales && (
        <PptosMasTotales
          open={openMasTotales}
          setOpen={setOpenMasTotales}
          title="Totales Finales"
        />
      )}

      {openInfoFacturacion && (
        <PptosInfoFacturacion
          open={openInfoFacturacion}
          setOpen={setOpenInfoFacturacion}
          title="Condiciones"
        />
      )}

      {openListCompras && (
        <ModalListaGastos
          open={openListCompras}
          handleClose={handleCloseListCompras}
          title="Gastos del negocio"
          origen="ventas"
          item={itemPptoSelected}
        />
      )}

      {openListFacturas && (
        <ModalListaFacturas
          open={openListFacturas}
          setOpen={setOpenListFacturas}
          title="Facturas de venta"
          origen="ventas"
        />
      )}

      {openDialogModalProjections && (
        <DialogFlowGeneral
          open={openDialogModalProjections}
          setOpen={setOpenDialogModalProjections}
          item={{ id: null }}
          tasksList={[]}
          currentTasks={{ id: null }}
          refreshObj={() => false}
        />
      )}

      {openDialogModalImports && (
        <DialogImports
          open={openDialogModalImports}
          setOpen={setOpenDialogModalImports}
          detail={detail}
        />
      )}

      <div className="md:hidden">
        <ModoMovil data={detail} />
      </div>

      <div className="hidden md:block">
        <ModoDesktop
          data={detail}
          setOpen={setOpen}
          setOpenLinkProject={setOpenLinkProject}
          access={access}
        />
      </div>

      <div className={`m-2 ms-0 ${showOptionMenu === "items" ? "mb-3" : ""}`}>
        <MenuSuperior
          estado_negocio={estado_negocio}
          showOptionMenu={showOptionMenu}
          setShowOptionMenu={setShowOptionMenu}
          setOpenCond={setOpenCond}
          setOpenMasTotales={setOpenMasTotales}
          setOpenInfoFacturacion={setOpenInfoFacturacion}
          setOpenDialogModalProjections={setOpenDialogModalProjections}
          handleOpenListCompras={handleOpenListCompras}
          setOpenListFacturas={setOpenListFacturas}
        />
      </div>

      {showOptionMenu !== "tasks" &&
      showOptionMenu !== "tasks2" &&
      showOptionMenu !== "tasks3" &&
      showOptionMenu !== "resumen" ? (
        <div className="row">
          <div className="col d-flex">
            <FormActions
              loadIniBudget={loadIni}
              openInfoInicial={open}
              setOpenInfoInicial={setOpen}
            />
          </div>
        </div>
      ) : (
        ""
      )}

      {showOptionMenu !== "tasks" &&
      showOptionMenu !== "tasks2" &&
      showOptionMenu !== "tasks3" &&
      perfil !== 9 ? (
        <div
          className="p-box-cards-totales"
          style={{ position: "relative", paddingBottom: "15px" }}
        >
          <CardTotalCliente setOpenTotales={setOpenMasTotales} />
          <CardGastoP setOpenTotales={setOpenMasTotales} />
          <CardUtilidadP setOpenTotales={setOpenMasTotales} />
          {estado_negocio === "aprobado" && (
            <>
              <CardGastoR />
              <CardUtilidadR />
            </>
          )}
          {validacion_estado === "por validar" && access.a21 ? (
            <span
              style={{
                position: "absolute",
                bottom: "0px",
                right: "10px",
                fontSize: "12px",
              }}
            >
              Rentabilidad óptima: 40%
            </span>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {estado_negocio === "aprobado" &&
      showOptionMenu !== "tasks" &&
      showOptionMenu !== "tasks2" &&
      showOptionMenu !== "tasks3" &&
      showOptionMenu !== "resumen" &&
      perfil !== 9 ? (
        <div className="d-flex">
          {/* <div className='d-flex' style={{ width: '325px' }}>
                        <CardTotalProyectadoIngresos />
                    </div> */}
          <div className="d-flex" style={{ width: "300px" }}>
            <CardTotalFacturacion />
          </div>
          {/* <div className='d-flex' style={{ width: '300px' }}>
                        <CardTotalCobrado />
                    </div>
                    <div className='d-flex' style={{ width: '325px' }}>
                        <CardTotalProyectadoEgresos />
                    </div>
                    <div className='d-flex' style={{ width: '300px' }}>
                        <CardTotalPagado />
                    </div> */}
        </div>
      ) : (
        ""
      )}

      <div className="row mt-3 p-pptos-form-box">
        {" "}
        {/* bloque */}
        {showOptionMenu === "items" && (
          <div className="flex justify-between items-center">
            <button
              className="btn text-xs hover:text-[#8E24AA] flex items-center gap-1"
              onClick={() => setOpenDialogModalImports(true)}
            >
              <Import className="w-4 h-4" />
              <span>Importar items</span>
            </button>

            <div className="me-3">
              <a href="#page-inicio-avance">
                <Tooltip title="Avanzar al comienzo">
                  <i
                    className="bi bi-arrow-left"
                    style={{ color: "var(--primary-color)", fontSize: "20px" }}
                  ></i>
                </Tooltip>
              </a>
              <a href="#page-final-avance">
                <Tooltip title="Avanzar al final">
                  <i
                    className="bi bi-arrow-right ms-1"
                    style={{ color: "var(--primary-color)", fontSize: "20px" }}
                  ></i>
                </Tooltip>
              </a>
            </div>
          </div>
        )}
        {/* <div className='text-end'>
                    {margen_sobre_costo ?
                        <span className='me-2 font-bold'>Margen sobre costo</span>
                        :
                        <span className='me-2 font-bold'>Margen sobre precio venta</span>
                    }
                </div> */}
        {estado_negocio === "aprobado" &&
        showOptionMenu === "resumen" &&
        perfil !== 9 ? (
          <Resumen
            items={items}
            addTitle={addTitle}
            handleOpenListCompras={handleOpenListCompras}
          />
        ) : (
          ""
        )}
        {showOptionMenu === "items" ? (
          <SectionItems
            items={items}
            addTitle={addTitle}
            handleOpenListCompras={handleOpenListCompras}
          />
        ) : (
          ""
        )}
        {showOptionMenu === "tasks" && !isMobile ? (
          <SectionTasks2
            id_ppto={detail.id}
            items={items}
            addTitle={addTitle}
          />
        ) : (
          ""
        )}
        {showOptionMenu === "tasks3" && !isMobile ? (
          <SectionTasks3
            id_ppto={detail.id}
            items={items}
            addTitle={addTitle}
          />
        ) : (
          ""
        )}
        {showOptionMenu === "tasks" && isMobile ? (
          <SectionTaskMovil id_ppto={detail.id} />
        ) : (
          ""
        )}
        {openInitialServices && (
          <DialogInitialService
            open={openInitialServices}
            setOpen={setOpenInitialServices}
          />
        )}
      </div>
    </div>
  );
};

const MenuSuperior = (props) => {
  const { perfil } = useSelector((state) => state.auth);
  const {
    estado_negocio,
    showOptionMenu,
    setShowOptionMenu,
    setOpenCond,
    setOpenMasTotales,
    setOpenInfoFacturacion,
    setOpenDialogModalProjections,
    handleOpenListCompras,
    setOpenListFacturas,
  } = props;

  console.log({ showOptionMenu });

  return (
    <>
      {estado_negocio === "aprobado" && perfil !== 9 && (
        <Link
          to=""
          className={`btn btn-link p-links-line ${showOptionMenu === "resumen" ? "active" : ""}`}
          onClick={() => setShowOptionMenu("resumen")}
        >
          Resumen
        </Link>
      )}

      {perfil !== 9 && (
        <>
          <button
            className={`btn btn-link p-links-line ${showOptionMenu === "items" ? "active" : ""}`}
            onClick={() => setShowOptionMenu("items")}
          >
            Ítems
          </button>
          <button
            className="btn btn-link p-links-line"
            onClick={() => setOpenCond(true)}
          >
            Condiciones
          </button>
          <button
            className="btn btn-link p-links-line"
            onClick={() => setOpenMasTotales(true)}
          >
            Montos finales
          </button>
          <button
            className="btn btn-link p-links-line"
            onClick={() => setOpenInfoFacturacion(true)}
          >
            Info facturación
          </button>

          {/*  {estado_negocio === 'aprobado' &&
                        <> */}
          <button
            className="btn btn-link p-links-line"
            onClick={() => setOpenDialogModalProjections(true)}
          >
            Flujos proyectados
          </button>
          <button
            className="btn btn-link p-links-line"
            onClick={() => handleOpenListCompras("general", null)}
          >
            Ver gastos
          </button>
          <button
            className="btn btn-link p-links-line"
            onClick={() => setOpenListFacturas(true)}
          >
            Ver facturas
          </button>
          {/* </>
                    } */}
        </>
      )}

      <Link
        to=""
        className={`btn btn-link p-links-line ${showOptionMenu === "tasks" ? "active" : ""}`}
        onClick={() => setShowOptionMenu("tasks")}
      >
        Tareas
      </Link>

      {/* <Link
                to=""
                className={`btn btn-link p-links-line ${showOptionMenu === 'tasks3' ? 'active' : ''}`} onClick={() => setShowOptionMenu('tasks3')}>
                Tareas3
            </Link> */}
    </>
  );
};

const ModoMovil = ({ data }) => {
  const { numero, referencia, cliente, estado_negocio } = data;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div className="p-movil-volver">
          <Link
            to={-1}
            className="d-inline-flex align-items-center p-arrow-back"
          >
            <i className="bi bi-arrow-left"></i>
            <span className="ms-2">
              {estado_negocio === "aprobado" ? "Proyecto" : "Presupuesto"} #
              {numero}
            </span>
          </Link>
        </div>
        <div className="p-box-movil-referencia">
          <h3>{referencia}</h3>
          <h3>cliente: {cliente}</h3>
        </div>
      </Grid>
    </Grid>
  );
};

const ModoDesktop = ({ data, setOpen, setOpenLinkProject }) => {
  const [editNumber, setEditNumber] = useState(false);
  const dispatch = useDispatch();

  const {
    id,
    numero,
    fecha_asignacion,
    referencia,
    cliente,
    moneda,
    estado_negocio,
    id_area_negocio,
    area_negocio,
    reading_mode,
    nro_version_actual,
    template_mode,
    estado_cierre,
    validacion_estado,
  } = data;

  const handleChangeNumber = async (e) => {
    const newNumber = e.target.value;
    console.log({ newNumber });

    if (newNumber !== numero) {
      const result = await Model.update({
        url: `budgets/update-folio/${id}`,
        dataForm: {
          new_folio: newNumber,
        },
      });

      if (result) {
        dispatch(updateNewFolio(newNumber));
      }

      setEditNumber(false);
    }
  };

  return (
    <div className="row">
      <div className="col">
        <h2 className="p-f-referencia">
          {template_mode ? (
            <span className="p-text-template-mode">MODO EDICIÓN PLANTILLA</span>
          ) : (
            <span>
              <span>
                {id === null || id === 0
                  ? "Nuevo presupuesto"
                  : estado_negocio === "aprobado"
                    ? "Proyecto"
                    : "Presupuesto"}
                {!editNumber && (
                  <Link
                    to=""
                    className="ms-1 text-[#595759] hover:underline hover:text-[#595759]"
                    onClick={() => setEditNumber(true)}
                  >
                    #{numero}
                  </Link>
                )}
              </span>
              {editNumber && (
                <input
                  className="ms-2 p-1 w-[100px]"
                  type="text"
                  defaultValue={numero}
                  onBlur={handleChangeNumber}
                  autoFocus
                />
              )}
            </span>
          )}
          <span className="p-f-linea">|</span>{" "}
          <span>{referencia || "Sin referencia de venta"}</span>
          <img
            src={iconEdit}
            alt="img editar"
            title="editar datos iniciales"
            onClick={() => setOpen(true)}
          />
          {nro_version_actual > 0 && (
            <span
              style={{
                fontSize: "12px",
                color: "rgb(143, 36, 170)",
                marginLeft: "10px",
              }}
            >
              Versión {nro_version_actual}
            </span>
          )}
          {reading_mode && (
            <div className="ms-3" style={{ color: "#8E24AA" }}>
              <i className="bi bi-eye"></i>
              <span className="ms-1" style={{ textTransform: "none" }}>
                Modo: lectura
              </span>
            </div>
          )}
          {estado_negocio === "anulado" && (
            <div>
              <span className="p-label-anulado-form">Anulado</span>
            </div>
          )}
          {estado_cierre !== "abierto" && (
            <div>
              <span className={`p-label-${estado_cierre}-form`}>
                {estado_cierre === "cerrado" && (
                  <i className="bi bi bi-lock"></i>
                )}
                {estado_cierre === "pausado" && (
                  <i className="bi bi-pause-circle"></i>
                )}
                <label className="ms-1">{estado_cierre}</label>
              </span>
            </div>
          )}
          {parseFloat(id) === 0 && validacion_estado === "por validar" ? (
            <div>
              <span className={`p-label-porvalidar-form`}>
                {estado_cierre === "cerrado" && (
                  <i className="bi bi bi-lock"></i>
                )}
                {estado_cierre === "pausado" && (
                  <i className="bi bi-pause-circle"></i>
                )}
                <label className="ms-1">requiere validación</label>
              </span>
            </div>
          ) : (
            ""
          )}
        </h2>
        <h2 className="p-f-referencia">
          <span className="p-f-fecha">
            Fecha: {moment(fecha_asignacion).format("DD-MM-YYYY")}
          </span>
          <span className="p-f-linea">|</span>
          <span className="p-f-moneda">Moneda: {moneda}</span>
          <span className="p-f-linea">|</span>
          <span className="p-f-cliente">Cliente: {cliente || "Ninguno"}</span>
        </h2>

        {parseInt(id_area_negocio) > 0 && (
          <h2 className="mb-2 p-f-referencia">
            <span className="p-f-moneda" style={{ textTransform: "none" }}>
              Unidad de negocio:{" "}
              <label style={{ textTransform: "capitalize" }}>
                {area_negocio || "---"}
              </label>
            </span>
          </h2>
        )}
      </div>
    </div>
  );
};

const SectionItems = ({ items, addTitle, handleOpenListCompras }) => {
  return (
    <div className="col p-pptos-form-tabla p-0 animate__animated animate__fadeIn">
      {" "}
      {/* bloque items */}
      <div className="table-responsive max-h-[500px] overflow-y-auto">
        {items?.length > 0 ? (
          <TablaPptos
            addTitle={addTitle}
            handleOpenListCompras={handleOpenListCompras}
          />
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ height: "300px" }}
          >
            <img src={iconInitial} alt="Agregar servicios" />
            <h3
              style={{ color: "#78667E", fontSize: "16px", marginTop: "15px" }}
            >
              Empieza agregando los servicios para crear tu presupuesto
            </h3>
            <button
              className="btn p-btn-primary mt-3"
              onClick={addTitle}
              style={{ width: "200px" }}
            >
              <i className="bi bi-plus"></i> Agregar servicios
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const SectionTasks2 = ({ id_ppto, items, addTitle }) => {
  return (
    <div className="col p-pptos-form-tabla p-0 animate__animated animate__fadeIn">
      {" "}
      {/* bloque items */}
      <div className="table-responsive">
        <ProjectsTaskNew2 id_ppto={id_ppto} />
      </div>
    </div>
  );
};

const SectionTasks3 = ({ id_ppto }) => {
  return (
    <div className="p-0 animate__animated animate__fadeIn">
      <ProjectsTaskNewV3 id_ppto={id_ppto} />
    </div>
  );
};

const SectionTaskMovil = ({ id_ppto }) => {
  const [taskList, setTaskList] = useState([]);
  const [openFormMovil, setOpenFormMovil] = useState(false);
  const [taskSelected, setTaskSelected] = useState(null);

  const getTasks = useCallback(async () => {
    const results = await Model.getAll({
      url: `tasks/movil/by-project/${id_ppto}`,
    });
    setTaskList(results);
  }, [id_ppto]);

  const handleOpenForm = (item) => {
    setTaskSelected(item);
    setOpenFormMovil(true);
  };

  useEffect(() => {
    getTasks();
  }, [getTasks]);

  return (
    <>
      {openFormMovil ? (
        <DialogFormMovil
          open={openFormMovil}
          setOpen={setOpenFormMovil}
          taskId={taskSelected.id}
        />
      ) : (
        ""
      )}

      <div className="mt-3" style={{ marginBottom: "70px" }}>
        {taskList.map((it) => (
          <Link
            key={it.id}
            to=""
            onClick={() => handleOpenForm(it)}
            style={{
              textAlign: "left",
              textDecoration: "none",
            }}
          >
            <TaskOneMovil
              key={it.id}
              task={it}
              handleChangeStatus={null}
              from="project"
            />
          </Link>
        ))}
      </div>
    </>
  );
};
